import { watch } from 'vue'
import type { AgencyServedPortRef } from '@gat-ship/types'
import { reconcileSelectedPort } from '../model/portcall-step-options'

/**
 * Keeps the selected port-of-call consistent with the chosen agency. Whenever
 * the agency's served-port list changes — a new agency was picked, or its ports
 * finished loading — a still-valid selection is kept; otherwise it falls back to
 * that agency's default port, or clears when there's neither.
 *
 * The port list is agency-scoped, so this is the seam that stops a stale port
 * (belonging to the previously chosen agency) surviving an agency change. Wired
 * once from the step-flow setup; `setPort` applies both the form value and the
 * sidebar label (`''` clears both).
 */
export function usePortcallPortReset(options: {
  agencyPorts: () => readonly AgencyServedPortRef[] | undefined
  selectedPortCode: () => string
  setPort: (code: string, label: string) => void
}) {
  const { agencyPorts, selectedPortCode, setPort } = options
  watch(agencyPorts, (ports) => {
    const next = reconcileSelectedPort(selectedPortCode(), ports ?? [])
    const nextCode = next?.locationCode ?? ''
    if (nextCode === selectedPortCode()) return
    setPort(nextCode, next?.name ?? '')
  })
}
